type Header = {
  key: string;
  label: string;
  sortable?: boolean;
  style?: React.CSSProperties;
};

export const SEARCHCASE_HEADERS: Header[] = [
  //{ key: "customerAccountNo", label: "Patient Account No", sortable: true, style: { width: "13%" } },
  {
    key: "subjectFullName",
    label: "Patient Full Name",
    sortable: true,
    style: { width: "15%" },
  },
  {
    key: "dateOfExam",
    label: "Date Of Exam",
    sortable: true,
    style: { width: "12%" },
  },
  {
    key: "casePriorityDesc",
    label: "Priority",
    sortable: true,
    style: { width: "6%" },
  },
  {
    key: "caseTypeDesc",
    label: "Case Type",
    sortable: true,
    style: { width: "11%" },
  },
  {
    key: "masterClaimNumber",
    label: "Claim No",
    sortable: true,
    style: { width: "10%" },
  },
  {
    key: "locationOfExam",
    label: "Location Of Exam",
    sortable: true,
    style: { width: "12%" },
  },
  {
    key: "qmeDoctorName",
    label: "Doctor Name",
    sortable: true,
    style: { width: "12%" },
  },
 
  {
    key: "caseStageName",
    label: "Case Stage",
    sortable: true,
    style: { width: "7%" },
  },
  {
    key: "actions",
    label: "Action",
  },
];

export const RUSH_NOTES_HEADERS: Header[] = [
  { key: "patientName", label: "Patient Name", style: { width: "25%" } },
  {
    key: "appointmentDateTime",
    label: "Appointment Date & Time",

    style: { width: "15%" },
  },
  {
    key: "noteCategoryDesc",
    label: "Notes Category",

    style: { width: "15%" },
  },
  {
    key: "noteContent",
    label: "Note",

    style: { width: "15%" },
  },
  {
    key: "createdByName",
    label: "Added On | By",

    style: { width: "15%" },
  },
  {
    key: "isAlwaysVisible",
    label: "Expires (In Days)",

    style: { width: "14%" },
  },
  {
    key: "countOfFiles",
    label: "File",
    style: { width: "5%" },
  },

];